import React from 'react';
import {SortableColumnState} from '../../types';

type CellProps = {
    content: any;
    prop?: any;
    classNames?: string;
    header?: boolean;
    sortable?: boolean;
    setSort?: (state: SortableColumnState) => void;
    sortState?: SortableColumnState;
};

export const Cell: React.FunctionComponent<CellProps> = ({
                                                             content,
                                                             prop,
                                                             header,
                                                             sortable = false,
                                                             setSort,
                                                             sortState,
                                                             classNames
                                                         }) => {

    const cellClassNames = [
        classNames && classNames,
        header && 'cell-header',
        'cell'
    ]
        .filter(Boolean)
        .join(' ');

    let additionalCellProps = {};
    if (sortable && setSort) {
        additionalCellProps = {
            ...additionalCellProps,
            onClick: () => {
                // toggle sort dir
                if (sortState?.column === prop) {
                    const direction = (sortState?.direction === 'asc') ? 'desc' : 'asc';
                    setSort({
                        column: prop,
                        direction
                    });
                } else {
                    setSort({
                        column: prop,
                        direction: 'asc'
                    })
                }
            },
            style: {cursor: 'pointer'}
        }
    }

    const cellMarkup = header ? (
        <th className={cellClassNames}
            {...additionalCellProps}
        >
            {content}
            {sortable && sortState?.column === prop && sortState?.direction === 'asc' && <i className="fas fa-caret-up pl-2"/>}
            {sortable && sortState?.column === prop && sortState?.direction === 'desc' && <i className="fas fa-caret-down pl-2"/>}
        </th>
    ) : (
        <td className={cellClassNames}
            {...additionalCellProps}
        >
            {content}
        </td>
    );

    return (cellMarkup);
};